var footerPublic = {
    connect:"SIGUENOS",
    news:"",
    go:"IR",
    welcome:"Bienvenido",
    rewards:"Recompensas",
    registeragent:"Registro para Agente",
    registeragency:"Registro para agencia",
    login:"Acceso",
    lang:"English",
    contact:"Contacto",
    copyright:"© 2023 Marival Resorts para Agentes de Viajes. Todos los derechos reservados.",
    cookiePolicy:"Política de Cookies",
    privacyPolicy:"Aviso de Privacidad"

}
module.exports = footerPublic
